import React from 'react'
// import React, { useState } from "react";
import { Link } from 'gatsby'
import Seo from '../components/seo'
import Layout from '../components/layout/layout'

import { Container, Row, Col, Image } from 'react-bootstrap'
import { HomeMeta } from '../data/metaData'
import { StaticImage } from 'gatsby-plugin-image'
import LazyLoad from 'react-lazy-load'

// For Event Slider
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation } from 'swiper/modules';

// import { Animations } from "../components/animations";

import DgBankLogo from '../images/dgpay-plus-logo.svg';
import Logo1 from '../images/country/us.svg';
import Logo2 from '../images/country/ph.svg';
import Logo3 from '../images/country/so.svg';
import Logo4 from '../images/country/ae.svg';
import Logo5 from '../images/country/bs.svg';
import Logo6 from '../images/country/pg.svg';
import Logo7 from '../images/country/ng.svg';
import Logo8 from '../images/country/gh.svg';
import Logo9 from '../images/country/ht.svg';
import Logo10 from '../images/country/bd.svg';
import Logo11 from '../images/country/ao.svg';
import Logo12 from '../images/country/gn.svg';
import Logo13 from '../images/country/bm.svg';
import Logo14 from '../images/country/iq.svg';
import Logo15 from '../images/country/sn.svg';
import Logo16 from '../images/country/bi.svg';
import Logo17 from '../images/country/co.svg';
import Logo18 from '../images/country/za.svg';
import Logo19 from '../images/country/ci.svg';
import Logo20 from '../images/country/gb.svg';
import Logo21 from '../images/country/ke.svg';
import Logo22 from '../images/country/gm.svg';
import Logo23 from '../images/country/bf.svg';
import Logo24 from '../images/country/mg.svg';
import Logo25 from '../images/country/cm.svg';


// import DigipayHomeBanner from '../animations/homepage/Home_page.json';
const EventsList = React.lazy(() => import('../components/events-list'))
const BlogList = React.lazy(() => import('../components/blog-list'))
const CaseStudiesList = React.lazy(() =>
  import('../components/case-studies-list')
)
const ClientTestimonial = React.lazy(() =>
  import('../components/client-testimonial')
)

export const Head = () => (
  <>
    <Seo
      title={HomeMeta.metaTitle}
      description={HomeMeta.metaDescription}
      ogTitle={HomeMeta.ogTitle}
      ogDescription={HomeMeta.ogDescription}
      ogType={HomeMeta.ogType}
      ogSiteName={HomeMeta.ogSiteName}
      ogImage={HomeMeta.ogImage}
      twitterCard={HomeMeta.twitterCard}
      twitterCreator={HomeMeta.twitterCreator}
      twitterTitle={HomeMeta.twitterTitle}
      twitterDescription={HomeMeta.twitterDescription}
      twitterImage={HomeMeta.twitterImage}
    />

    <meta name="msvalidate.01" content="B64D72F411EC60D00539DB53C2A356BA" />
  </>
)


const SectionDarkBackgroundPattren = '../images/sectino-dark-background-pattren.webp'
const DigipayHomeBannerImg = '../images/digipay-home-banner-img.webp'
const DigipayHomeMobileMoneySolution =
  '../images/digipay-home-mobile-money-solution.webp'
const DigipayHomeAgencyBankingSolution =
  '../images/digipay-home-agency-banking-solution.webp'
const DigipayHomeInternationalRemittanceSolution =
  '../images/digipay-home-international-remittance-solution.webp'
const DigipayHomePageCtaImg =
  '../images/digipay-home-page-cta-img.webp'
const PrepaidCardImg = '../images/digipay-home-prepaid-card-img.webp'
const EkycImg = '../images/digipay-home-ekyc-img.webp'
const ScanThruImg = '../images/digipay-home-scan-thru-img.webp'
const SectionPageCta = '../images/section-cta-bg.webp'

const IndexNewPage = () => {
  // const ScheduleMeetingBannerImg1 = '../images/schedule-meeting-home-banner-img1.png';
  // const ScheduleMeetingBannerImg2 = '../images/schedule-meeting-home-banner-img2.png';
  // const DigipayHomeMobileMerchantSolution = '../images/digipay-home-mobile-merchant-solution.webp';

  // const [showScheduleCall, setScheduleCall] = useState(false);

  // const handleShowScheduleCall = () => setScheduleCall(true);
  // const handleCloseScheduleCall = () => setScheduleCall(false);
  const Mapbgimage = '../images/global-country-map.png'

  const paymentsolution = [
    {
      title: "Banks & neo banks",
      description: "Deliver omnichannel customer experiences along with secure payment infrastructure.",
      iconclass: "bank",
    },
    {
      title: "Telcos",
      description: "Tap new revenue streams offering bill payment, TV subscription, & more with digital wallet.",
      iconclass: "telcos",
    },
    {
      title: "NBFI",
      description: "Enabling complete real-time payments interoperability with our trusted digital wallet solution.",
      iconclass: "nbfi",
    }
  ];

  const CheckIconSection = [
    {
      topTitle: "Mobile money",
      keyname: "mobilemoney",
      topDescription: "Empowering financial and non-financial institutions with our top-class mobile wallet solution to allow their customers to securely send, store, and receive money instantly at a fingertip.",
      listname: [
        {
          listTitle: "A solution for everyone",
          listDescription: "Our able digital wallet solution caters to banked & unbanked customers and contributes to the country’s economic growth by allowing them to make transactions at their fingertips.",
        },
        {
          listTitle: "Multiple payment methods",
          listDescription: "Our solution is armed with extensive contactless payment methods like QR code, NFC, USSD, & virtual cards to make your customer's transactions a whole lot easier & quicker.",
        },
        {
          listTitle: "Customizable configurations",
          listDescription: "You get a dynamic configuration and customization option in our digital wallet system to monitor and optimize system performance to meet your business needs.",
        }
      ],
      linkUrl: "/mobile-money-payment-solutions",
      linkText: "Explore further",
    },
    {
      topTitle: "Agency banking",
      keyname: "agencyBanking",
      topDescription: "Enabling banks to extend their banking network and trigger financial inclusion by deploying agents or business correspondents with e-wallets in their mobile devices in remote areas.",
      listname: [
        {
          listTitle: "Boost financial inclusion",
          listDescription: "Empowering banks to provide banking services in rural areas to banked and unbanked customers.",
        },
        {
          listTitle: "Low operational costs",
          listDescription: "Save and reduce your costs by leveraging the branchless banking feature using our agency banking solution.",
        },
        {
          listTitle: "Lift customers’ experience",
          listDescription: "Provide banking services to all your customers with easy accessibility, flexibility, and convenience.",
        }
      ],
      linkUrl: "/agency-banking-solutions",
      linkText: "Know all about it",
    },
    {
      topTitle: "International remittance",
      keyname: "internationalRemittance",
      topDescription: "Allow your customers to make instant international transfers without any waiting period, at most competitive forex rates, absolutely paperless, instant transfers at competitive fees.",
      listname: [
        {
          listTitle: "Boost economic growth",
          listDescription: "Ease the credit constraints of unbanked households in poor rural areas, facilitate asset accumulation and business investments, promote financial literacy, and reduce poverty.",
        },
        {
          listTitle: "Seamless money transfer",
          listDescription: "Our innovative, technology-led financial solution is armed with multiple channels to quickly, securely, and smoothly send and receive remittances across the globe.",
        },
        {
          listTitle: "Easy accessibility",
          listDescription: "Be it day or night, domestic or international, no matter where you are, you can send and receive remittance 24/7 with a single click on your phone.",
        }
      ],
      linkUrl: "/cross-border-payment-solutions",
      linkText: "Get more insights",
    },
    {
      topTitle: "Prepaid cards",
      keyname: "prepaidCards",
      topDescription: "Easily issue, activate and manage your prepaid card programs with security and convenience. It's user friendly, simple, accessible, and scalable for all.",
      listname: [
        {
          listTitle: "All in one - issue & manage cards",
          listDescription: "Our all-in-one prepaid card solution has it all! From card issuance, activation, and management, to an admin view of the solution, manage all card operations at your fingertips.",
        },
        {
          listTitle: "Integrate globally",
          listDescription: "Access a global network of top banks & payment networks. Seamlessly integrate with industry leaders for a streamlined connection, opening up new possibilities for success.",
        },
        {
          listTitle: "Enhanced customer experience",
          listDescription: "Empower your customers with our advanced self-service features. Let them activate cards, make payments, load funds, check balances, view transactions & more, leading to enhanced satisfaction.",
        }
      ],
      linkUrl: "/prepaid-cards-solution",
      linkText: "Explore innovative solution",
    },
    {
      topTitle: "eKYC",
      keyname: "ekyc",
      topDescription: "Effortless onboarding. Secure verifications. Accelerated growth. A perfect eKYC solution for streamlined compliance and seamless integration, ensuring ongoing success.",
      listname: [
        {
          listTitle: "Fast & accurate onboarding",
          listDescription: "Experience the power of Fast & accurate onboarding. Get precise KYC results, reduce fraud risks, and save time & costs with one-click onboarding, for unparalleled business success.",
        },
        {
          listTitle: "Flexible & scalable",
          listDescription: "Unlock limitless growth potential with our flexible & scalable eKYC solution. Effortlessly handle high volumes of onboarding requests, adapting to your evolving needswith ease.",
        },
        {
          listTitle: "Integration with AML & CFT databases",
          listDescription: "Ensure compliance and protect your business with seamless integration with AML & CFT databases. Experience holistic risk mitigation, ensuring compliance onboarding at every step.",
        }
      ],
      linkUrl: "/ekyc-solution",
      linkText: "Discover the ultimate solution",
    },
    // {
    //   topTitle: "Scan & thru",
    //   keyname: "scanThru",
    //   topDescription: "Revolutionize customer shopping with Scan & thru. Speedy, secure checkouts and seamless billing all in one place just a few taps away, thereby simplifying transactions and ensuring fast hassle-free checkouts.",
    //   listname: [
    //     {
    //       listTitle: "Automated contactless payments",
    //       listDescription: "Experience automated contactless payments with few taps on the screen eliminating the need for physical contact or cash which saves time, enhances convenience, and ensures customer safety.",
    //     },
    //     {
    //       listTitle: "Enhanced customer satisfaction",
    //       listDescription: "Deliver exceptional customer experience with quick seamless checkouts, reduced wait times, and shopping convenience, thereby keeping the customers happy & loyal for long-term success.",
    //     },
    //     {
    //       listTitle: "Accuracy & efficiency",
    //       listDescription: "With automation, the chances for errors are minimized, leading to precise data capture and payments. Also, with streamlined operations, and faster checkouts, the efficiency of business increases trifold.",
    //     }
    //   ],
    //   linkUrl: "/scan-and-thru-solution",
    //   linkText: "Know more about it",
    // },
  ]


  const countryListitem = [
    {
      logo: Logo1,
      title: "United States"
    },
    {
      logo: Logo2,
      title: "Philippines"
    },
    {
      logo: Logo3,
      title: "Somalia"
    },
    {
      logo: Logo4,
      title: "UAE"
    },
    {
      logo: Logo5,
      title: "Bahamas"
    },
    {
      logo: Logo6,
      title: "Papua New Guinea"
    },
    {
      logo: Logo7,
      title: "Nigeria",
      slug: "/fintech-digital-payments-in-nigeria"
    },

    {
      logo: Logo8,
      title: "Ghana"
    },
    {
      logo: Logo9,
      title: "Haiti"
    },
    {
      logo: Logo10,
      title: "Bangladesh"
    },
    {
      logo: Logo11,
      title: "Angola"
    },
    {
      logo: Logo12,
      title: "Guinea"
    },
    {
      logo: Logo13,
      title: "Bermuda"
    },
    {
      logo: Logo14,
      title: "Iraq"
    },
    {
      logo: Logo15,
      title: "Senegal"
    },
    {
      logo: Logo16,
      title: "Burundi"
    },
    {
      logo: Logo17,
      title: "Colombia"
    },
    {
      logo: Logo18,
      title: "South Africa"
    },
    {
      logo: Logo19,
      title: "Cote dlvoire"
    },
    {
      logo: Logo20,
      title: "United Kingdom"
    },
    {
      logo: Logo21,
      title: "Kenya"
    },
    {
      logo: Logo22,
      title: "Gambia"
    },
    {
      logo: Logo23,
      title: "Burkina Faso"
    },
    {
      logo: Logo24,
      title: "Madagascar"
    },
    {
      logo: Logo25,
      title: "Cameroon"
    },
  ]
  return (
    <>
      <Layout headerClass="navbar-dark">
        {/* Start Events Slider  */}
        {/* <section className="section banner-background d-md-flex align-items-center pb-lg-0" style={{ backgroundAttachment: `fixed` }}>
          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            autoplay={{
              delay: 9000,
              disableOnInteraction: false
            }}
            autoHeight={true}
            loop={true}
            navigation={true}
          >

            <SwiperSlide>
              <Container className="py-5 mt-lg-5">
                <Row className="g-5 align-items-center schedule-meeting-home-banner-img">
                  <Col lg={6} className="">
                    <StaticImage loading="lazy" className="banner-img1" src={ScheduleMeetingBannerImg1} width={582} height={528} alt="schedule-meeting-home-banner-img1" />
                    <Button size="lg" onClick={handleShowScheduleCall} onKeyDown={handleShowScheduleCall} className="btn-primary-theme btn-240 mt-4 mt-lg-5">
                      <span>Let's Meet</span>
                    </Button>
                  </Col>
                  <Col lg={6} className="text-center d-none d-lg-block">
                    <StaticImage loading="lazy" className="banner-img banner-img2" src={ScheduleMeetingBannerImg2} width={520} height={720} alt="schedule-meeting-home-banner-img2" />
                  </Col>
                </Row>
              </Container>
            </SwiperSlide>
            <SwiperSlide>
              <Container className="py-5 pb-lg-0 mt-lg-5">
                <Row className="g-5 align-items-center">
                  <Col lg={6} className="pb-lg-5 mb-lg-5">
                    <div className="banner-content">
                      <h1 className="title fw-bold mb-4-lg font-size-80">
                        Empowering <br /><span className="gradient-text1 font-size-120">FinTech</span><br /> Innovators
                      </h1>
                      <p className="text lead mb-0 text-dark max-width-650">
                        DigiPay.Guru is accelerating the digital wallet revolution by digitizing businesses of all sizes with its world-class digital payment solutions.
                      </p>
                      <Link to="/contact-us" className="btn btn-lg btn-primary-theme btn-240 mt-4 mt-lg-5">
                        <span>Request a Demo</span>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={6} className="text-center align-self-end d-none d-lg-block">
                    <StaticImage loading="lazy" className="banner-img" src={DigipayHomeBannerImg} width={624} height={788} alt="HomeBannerImg" />
                  </Col>
                </Row>
              </Container>
            </SwiperSlide>
          </Swiper>
        </section> */}
        {/* End Events Slider */}

        <section className='section section-background-dark pb-lg-0'>
          <Container className='py-5 pb-lg-0 mt-lg-5'>
            <Row className='g-5 align-items-center'>
              <Col lg={6} className='pb-lg-5 mb-lg-5'>
                <div className='banner-content'>
                  <h1 className='title text-white fw-bold mb-4-lg font-size-80'>
                    Empowering <br />
                    <span className='gradient-text1 font-size-120'>
                      FinTech
                    </span>
                    <br /> Innovators
                  </h1>
                  <p className='text lead mb-0 text-white opacity-75 max-width-650'>
                    DigiPay.Guru is accelerating the digital wallet revolution
                    by digitizing businesses of all sizes with its world-class
                    digital payment solutions.
                  </p>
                  <Link
                    to='/contact-us'
                    className='btn btn-lg btn-primary-theme btn-240 mt-4 mt-lg-5'
                  >
                    <span>Request a demo</span>
                  </Link>
                </div>
              </Col>
              <Col
                lg={6}
                className='text-center align-self-end d-none d-lg-block'
              >
                {/* <div className="">
                  <Animations animation={DigipayHomeBanner} />
                </div> */}
                {/* <LazyLoad offsetVertical={1000}> */}
                <StaticImage
                  loading='lazy'
                  className='banner-img'
                  src={DigipayHomeBannerImg}
                  width={624}
                  height={788}
                  alt='HomeBannerImg'
                />

                {/* <Image loading="lazy"
                    src="https://www.peerbits.com/images/digipay-home-banner-img.png"
                    width={624}
                    height={788}
                    alt="HomeBannerImg"
                    className="lazyload"
                    loading="lazy"
                  /> */}
                {/* </LazyLoad> */}
              </Col>
            </Row>
          </Container>
          <StaticImage
            style={{ position: 'absolute' }}
            className='section-background-image'
            loading='lazy'
            src={SectionDarkBackgroundPattren}
            alt='Banner Background Pattren'
          />
        </section>

        <section className='section position-relative'>
          <Container className='py-5'>
            <div className='w-75 mx-auto text-center'>
              <div
                className='section-title my-5 pb-3'
              // data-sal="slide-down"
              // data-sal-duration="1000"
              // data-sal-delay="0"
              // data-sal-easing="ease"
              >
                <h2 className='heading fw-semibold'>
                  Delivering digital payment solutions for a wide spectrum of
                  industries
                </h2>
              </div>
            </div>
            <Row className='g-5' xs={1} lg={3}>
              {paymentsolution?.map((item, index) => (
                <Col key={index}>
                  <div
                    className='center-icon-box text-center'
                  >
                    <div className='icon mb-3'>
                      <i className={`icon-size-100 digipay-home-sprit-icon-new ${item.iconclass}`}></i>
                    </div>
                    <h3 className='heading font-size-24 mb-4'>
                      {item.title}
                    </h3>
                    <p className='mb-0'>
                      {item.description}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className='section position-relative'>
          <Container>
            <div className='empowering-box text-center'>
              <div className='mb-5'>
                <LazyLoad offsetVertical={1000}>
                  <Image loading="lazy" className="dg-bank-logo lazyload" src={DgBankLogo} width={406} height={110} alt="logo" />
                </LazyLoad>
              </div>
              <div className='w-75 mx-auto'>
                <h2 className='mb-4 fw-semibold'>
                  DGPay+: digital payment platform
                </h2>
                <p className='m-0'>
                  A comprehensive suite designed to drive financial inclusion &
                  cashless adoption. Our ROI-centric next-gen digital payment
                  platform is armed with highly customizable features that
                  support every business model. It’s the one solution to
                  revolutionize banking in underserved markets, help financial
                  companies build more mature, flexible, and future-proof
                  digital platforms.
                </p>
              </div>
              <Link
                to='/advance-payment-platform-digipay-plus'
                className='btn btn-lg btn-primary-theme mt-4 mt-lg-5'
              >
                <span>Explore DGPay+ solutions</span>
              </Link>
            </div>
          </Container>
        </section>

        {CheckIconSection?.map((item, index) => (
          <section key={index} className={`section ${index % 2 === 0 ? '' : 'bg-light'}`}>
            <Container className='py-5'>
              <div className='section-title mb-5 w-75 pb-1'>
                <h2 className='mb-4 fw-semibold'>{item.topTitle}</h2>
                <p className='lead'>
                  {item.topDescription}
                </p>
              </div>
              <Row className='g-5 align-items-center'>
                <Col lg={5} className={`${index % 2 === 0 ? 'order-lg-2' : ''}`}>
                  {item.listname?.map((item, index) => (
                    <div key={index} className='clear'>
                      <div className='check-icon-box d-flex align-items-start mb-5'>
                        <i className='zmdi zmdi-check zmdi-hc-fw check-icon'></i>
                        <div className='px-4'>
                          <h3 className='heading h4'>{item.listTitle}</h3>
                          <p className='mb-0 font-size-16'>{item.listDescription}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {
                    item.linkUrl ? <Link to={item.linkUrl} className='btn btn-link px-0 ms-5'>
                      <span>{item.linkText}</span>{' '}
                      <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
                    </Link> :
                      <div className='btn btn-link px-0 ms-5'>
                        <span>{item.linkText}</span>{' '}
                        <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
                      </div>
                  }
                </Col>
                <Col lg={7}>
                  {
                    item.keyname === "mobilemoney" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage
                          loading='lazy'
                          src={DigipayHomeMobileMoneySolution}
                          width={736}
                          height={590}
                          alt='DigipayHomeMobileMoneySolution'
                        />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyname === "agencyBanking" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage
                          loading='lazy'
                          src={DigipayHomeAgencyBankingSolution}
                          width={735}
                          height={612}
                          alt='DigipayHomeAgencyBankingSolution'
                        />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyname === "internationalRemittance" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage
                          loading='lazy'
                          src={DigipayHomeInternationalRemittanceSolution}
                          width={736}
                          height={570}
                          alt='DigipayHomeInternationalRemittanceSolution'
                        />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyname === "prepaidCards" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage
                          loading='lazy'
                          src={PrepaidCardImg}
                          width={736}
                          height={577}
                          alt='PrepaidCardImg'
                        />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyname === "ekyc" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage
                          loading='lazy'
                          src={EkycImg}
                          width={729}
                          height={649}
                          alt='EkycImg'
                        />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyname === "scanThru" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage
                          loading='lazy'
                          src={ScanThruImg}
                          width={736}
                          height={597}
                          alt='ScanThruImg'
                        />
                      </LazyLoad> :
                      null
                  }
                </Col>
              </Row>
            </Container>
          </section>
        ))}




        <section className='section section-background-dark pb-0'>
          <Container>
            <Row className='g-5 align-items-center'>
              <Col lg={6} className='py-5'>
                <div className='section-title'>
                  <h2 className='heading fw-semibold mb-4 text-white'>
                    Become a pioneer of a{' '}
                    <span className='gradient-text1 fw-bold'>
                      cashless society
                    </span>{' '}
                    with Digipay
                  </h2>
                  <p className='text-white opacity-75'>
                    Engage your customers with an exceptional digital payment
                    experience and increase revenue by providing an end-to-end
                    solution to manage all payment needs with our
                    enterprise-grade and completely customizable mobile wallet
                    platform.
                  </p>
                  <Link
                    to='/contact-us'
                    className='btn btn-lg btn-primary-theme mt-4'
                  >
                    <span>Request a demo</span>
                  </Link>
                </div>
              </Col>
              <Col lg={6} className='text-center align-self-end'>
                <LazyLoad offsetVertical={1000}>
                  <StaticImage
                    loading='lazy'
                    src={DigipayHomePageCtaImg}
                    width={624}
                    height={494}
                    alt='Cashless society with Digipay'
                  />
                </LazyLoad>
              </Col>
            </Row>
          </Container>
          <StaticImage
            style={{ position: 'absolute' }}
            className='section-background-image'
            loading='lazy'
            src={SectionPageCta}
            alt='Section Page CTA'
          />
        </section>
        <ClientTestimonial sectionClass='bg-light' />
        <CaseStudiesList />
        <EventsList />
        <BlogList
          sectionClass='bg-white'
        // category='News, Case Studies'
        />
        <section className='section bg-light'>
          <Container>
            <div className='w-75 mx-auto text-center'>
              <div className='section-title my-5 pb-3'>
                <h2 className='heading fw-semibold'>
                  Our Global Experience</h2>
              </div>
            </div>
            <div className='text-cente mb-5 pb-4'>
              <StaticImage loading='lazy' src={Mapbgimage} width={1291} height={512} alt='Mapbgimage' />
            </div>
            <Row xs={2} md={3} lg={4} xl={5} as="ul" className="list-unstyled g-3">
              {countryListitem.map((item, index) => (
                <Col as="li" key={index}>
                  <div className="d-flex align-items-center mb-3">
                    <Image loading="lazy" className="lazyload me-3 rounded-1" src={item.logo} width={24} height={24} alt="logo" />

                    <h3 className="h4 fw-normal mb-0">
                      {item.slug ?
                        <Link className='text-current' to={item.slug}>{item.title}</Link> : item.title
                      }
                    </h3>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

      </Layout>

      {/* <Modal size="xl" show={showScheduleCall} onHide={handleCloseScheduleCall} centered backdrop="static" keyboard={false}>
        <Modal.Header className="flex-column border-0 pt-4 pt-lg-5 pb-0 text-center" style={{ backgroundColor: "#f5f8fa" }}>
          <h2 className="modal-title mb-3">Schedule Your Free Consultation</h2>
          <p className="mb-0">Please select a date and time from the calendar below to schedule your meeting. <br /><span className="fw-semibold">We’ll be there at WFIS Kenya, 2023 on 24th & 25th May!</span></p>
          <div className="text-end video-close-btn">
            <Button variant="" className="btn-close" onClick={handleCloseScheduleCall}></Button>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ backgroundColor: "#f5f8fa" }}>
          <div className="ratio ratio-16x9" style={{ minHeight: 500 }}>
            <iframe className="lazyload" loading="lazy" width="100%" height="670" src="https://meetings.hubspot.com/harsha-yadav/wfis-kenya" title="Schedule Call" frameBorder="0" allowFullScreen></iframe>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  )
}

export default IndexNewPage
